// extracted by mini-css-extract-plugin
export default {"banner":"BackendStatusBar_banner__Up9jT","text":"BackendStatusBar_text__5hYiq"};